import React, { useState } from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { toast } from 'sonner';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    toast.success('Thank you! We will get back to you soon.');
    setSubmitted(true);
    setFormData({ name: '', email: '', subject: '', message: '' });
  };

  return (
    <div className="min-h-screen bg-white" data-testid="contact-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-12">
          <h1
            className="text-4xl sm:text-5xl font-bold mb-4"
            style={{ fontFamily: 'Playfair Display, serif' }}
            data-testid="contact-title"
          >
            Contact Us
          </h1>
          <p className="text-lg text-gray-600">We'd love to hear from you</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Info */}
          <div>
            <h2 className="text-2xl font-bold mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
              Get In Touch
            </h2>

            <div className="space-y-6">
              <div className="flex items-start">
                <MapPin className="w-6 h-6 text-[#D4AF37] mr-4 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-semibold mb-1">Visit Our Store</h3>
                  <p className="text-gray-600">
                    6575 E Livingston Ave<br />
                    Reynoldsburg, OH 43068
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <Clock className="w-6 h-6 text-[#D4AF37] mr-4 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-semibold mb-1">Store Hours</h3>
                  <p className="text-gray-600">Open Daily: 9:00 AM – 9:00 PM</p>
                </div>
              </div>

              <div className="flex items-start">
                <Mail className="w-6 h-6 text-[#D4AF37] mr-4 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-semibold mb-1">Email Us</h3>
                  <p className="text-gray-600">info@neporaforyou.com</p>
                </div>
              </div>

              <div className="flex items-start">
                <Phone className="w-6 h-6 text-[#D4AF37] mr-4 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-semibold mb-1">Call Us</h3>
                  <a href="tel:614-762-2066" className="text-gray-600 hover:text-[#D4AF37] transition-colors">614-762-2066</a>
                </div>
              </div>
            </div>

            <div className="mt-8 p-6 bg-[#F9F9F9] rounded-lg">
              <h3 className="font-semibold mb-2">Free Local Pickup</h3>
              <p className="text-sm text-gray-600">
                Save on shipping! Order online and pick up your items at our store for free.
              </p>
            </div>
          </div>

          {/* Contact Form */}
          <div>
            <h2 className="text-2xl font-bold mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
              Send Us a Message
            </h2>

            <form onSubmit={handleSubmit} className="space-y-4" data-testid="contact-form">
              <div>
                <label className="block text-sm font-medium mb-1">Name *</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#D4AF37] focus:border-transparent"
                  data-testid="input-name"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Email *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#D4AF37] focus:border-transparent"
                  data-testid="input-email"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Subject *</label>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#D4AF37] focus:border-transparent"
                  data-testid="input-subject"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Message *</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows={6}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#D4AF37] focus:border-transparent"
                  data-testid="input-message"
                />
              </div>

              <button
                type="submit"
                className="w-full bg-[#D4AF37] text-white py-3 rounded-full hover:bg-[#B5952F] transition-colors font-medium"
                data-testid="submit-button"
              >
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
